"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplianceRoute = void 0;
const route_1 = require("../route");
const config_1 = require("../config");
class ComplianceRoute extends route_1.Route {
    getBaseUrl() {
        return config_1.configInstance.getComplianceUrl();
    }
}
exports.ComplianceRoute = ComplianceRoute;
//# sourceMappingURL=compliance-route.js.map